import Tabby from 'tabbyjs';
import SmoothScroll from 'smooth-scroll';
import Houdini from 'houdinijs';

document.addEventListener('DOMContentLoaded', () => {
  const tabsEl = document.querySelector('[data-tabs]');
  if (tabsEl) {
    // eslint-disable-next-line no-unused-vars
    const tab = new Tabby('[data-tabs]');
  }

  const subTabsEl = document.querySelector('[data-branch-tabs]');
  if (subTabsEl) {
    // eslint-disable-next-line no-unused-vars
    const subTab = new Tabby('[data-branch-tabs]');
  }

  const accordionCustomTabEl = document.querySelector(
    '[data-houdini-group="custom"]',
  );

  const accordionCustomTabSets = document.querySelectorAll(
    '[data-houdini-group-set]',
  );

  const setNames = [];

  if (accordionCustomTabSets.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < accordionCustomTabSets.length; i++) {
      if (
        !setNames.includes(accordionCustomTabSets[i].dataset.houdiniGroupSet)
      ) {
        setNames.push(accordionCustomTabSets[i].dataset.houdiniGroupSet);
      }
    }
  }

  if (accordionCustomTabEl && setNames) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < setNames.length; i++) {
      const accordionCustomTab = new Houdini(
        `[data-houdini-group-set="${setNames[i]}"]`,
        {
          isAccordion: true,
          collapseOthers: true,
          icon: false,
          btnClass: 'c-accordion__toggle',
        },
      );

      document.documentElement.addEventListener(
        'click',
        event => {
          let triggerElm = null;
          if (!event.target.classList.contains('c-accordion__toggle')) {
            triggerElm = event.target.closest('.c-accordion__toggle');
          } else {
            triggerElm = event.target;
          }

          if (triggerElm) {
            if (triggerElm.getAttribute('aria-expanded') === 'true') {
              accordionCustomTab.toggle(`#${triggerElm.dataset.houdiniToggle}`);
            }
          }
        },
        false,
      );
    }
  }

  const accordionProductCatTabEl = document.querySelector(
    '[data-houdini-group="product-category"]',
  );
  if (accordionProductCatTabEl) {
    // eslint-disable-next-line no-unused-vars
    const accordionProductCatTab = new Houdini(
      '[data-houdini-group="product-category"]',
      {
        isAccordion: true,
        collapseOthers: true,
        icon: false,
        btnClass: 'c-accordion__toggle',
      },
    );

    setTimeout(() => {
          const urlParams = new URLSearchParams(window.location.search);
          const accordionIndex = urlParams.get('product-tab');
          if (accordionIndex !== null && accordionProductCatTabEl) {
              const toggles = accordionProductCatTabEl.closest('.c-accordion').querySelectorAll('.c-accordion__toggle');
              const index = parseInt(accordionIndex, 10);

              if (!isNaN(index) && accordionIndex >= 0 && index < toggles.length) {
                  const toggleButton = toggles[index];
                  if (toggleButton && toggleButton.dataset.houdiniToggle && accordionIndex >= 1) {
                      accordionProductCatTab.toggle(`#${toggleButton.dataset.houdiniToggle}`);
                  }

                  const scroll = new SmoothScroll(null,{
                      speed: 500,
                      updateURL: false,
                      header: '#header',
                      offset: 20
                  });

                  scroll.animateScroll(toggleButton.closest('.c-accordion'));

              }
          }
      },500);

    document.documentElement.addEventListener(
      'click',
      event => {
        let triggerElm = null;
        if (!event.target.classList.contains('c-accordion__toggle')) {
          triggerElm = event.target.closest('.c-accordion__toggle');
        } else {
          triggerElm = event.target;
        }

        if (triggerElm) {
          if (triggerElm.getAttribute('aria-expanded') === 'true') {
            accordionProductCatTab.toggle(
              `#${triggerElm.dataset.houdiniToggle}`,
            );
          }
        }
      },
      false,
    );
  }
});
